import { useEffect, useState } from "react";
import EnterpriseService from "../../../common/services/enterprise-service";
import moment from "moment";
import { Col, Row } from "reactstrap";
import EventDetailCard from "./EventDetailCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function TodayEvents({ container, company_id }) {
  const [eventsToday, setEventsToday] = useState([]);
  const es = new EnterpriseService();

  useEffect(() => {
    getEventsToday();
  }, []);

  const getEventsToday = async () => {
    let result = null;

    if (company_id) {
      result = await es.getCompanyEventsCalendar(company_id, {
        date_from: moment().format("YYYY-MM-DD"),
        date_to: moment().add(24, "hours").format("YYYY-MM-DD"),
        limit: 6,
      });
    } else {
      result = await es.getPublicCompanyEvents({
        date_from: moment().format("YYYY-MM-DD"),
        date_to: moment().add(24, "hours").format("YYYY-MM-DD"),
        limit: 6,
      });
    }

    if (result && Array.isArray(result)) {
      setEventsToday(result);
    }
  };

  return (
    <>
      {eventsToday.length > 0 && (
        <>
          <div className="d-flex align-items-center gap-2 mb-3">
            <span className="page-title-icon page-title-icon-warning page-title-icon-sm">
              <FontAwesomeIcon icon="bolt" className="mx-0" />
            </span>
            <span className="fw-bold fs-5">{container.localeManager.strings.eventsNext24Hours}</span>
          </div>
          <Row className="g-3 mb-4">
            {eventsToday.map((event) => {
              return (
                <Col sm={12} md={6} lg={4} key={event.id}>
                  <EventDetailCard
                    event={event}
                    container={container}
                  ></EventDetailCard>
                </Col>
              );
            })}
          </Row>
        </>
      )}
    </>
  );
}
